import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';

import { gqlRequest } from '../../../common/helpers/request';
import { getCommentsAndSummaryAction, setCommentsAndSummaryAction } from '../slices/comments';

const queryGQL = `
  query getHostedWatchComments(
    $videoId: String,
    $commentsParams: HostedWatchCommentsInput,
    $summaryParams: HostedWatchCommentsSummaryInput,
  ) {
    comments: hostedWatchComments(
      videoId: $videoId,
      params: $commentsParams,
    ) {
      totalCount,
      entries {
        activeChildCount,
        deletedChildCount,
        time,
        id,
        index,
        parentId,
        status,
        created,
        updated,
        updateCount,
        html,
        author {
          id,
          firstName,
          lastName,
        }
      }
    }
    summary: hostedWatchCommentsSummary(
      videoId: $videoId,
      params: $summaryParams,
    ) {
      activeMessageCount,
      deletedMessageCount,
      entries {
        activeChildCount,
        time,
      }
    }
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(getCommentsAndSummaryAction.type),
    switchMap(({ payload }) =>
      gqlRequest({
        query: queryGQL,
        variables: {
          videoId: payload.videoId,
          commentsParams: {
            videoTime: payload.videoTime,
            from: payload.from,
            size: payload.size,
          },
          summaryParams: {
            videoTime: payload.videoTime,
            from: payload.from,
            size: payload.size,
          },
        },
      }).pipe(
        map(({ data: { comments, summary }, errors }) => {
          const resultData = {
            comments: [],
            summary: {
              activeMessageCount: 0,
              deletedMessageCount: 0,
              entries: [],
            },
          };

          if (!errors.length) {
            resultData.comments = comments.entries;
            resultData.summary = summary;
          }

          return setCommentsAndSummaryAction(resultData);
        }),
      ),
    ),
  );
